<template>
    <div class="view view--events">
        <data-table
            class="has-margin-b45"
            v-bind:data="tableData"
            v-on:sort="sortDataTable"
        ></data-table>

        <btn
            class="is-success"
            type="default"
            href="/admin#/events/create"
            v-html="__('+ Add Event')"
        ></btn>

        <modal
            class="is-narrow"
            v-bind:title="__('Are you sure?')"
            v-bind:is-open="isOpenDeleteModal"
            v-on:close-modal="isOpenDeleteModal = false"
        >
            <template v-slot:body>
                <p
                    class="has-text-center"
                    v-html="
                        __(
                            'Are you sure you want to delete this event?<br />This action cannot be undone.'
                        )
                    "
                ></p>
            </template>
            <template v-slot:footer>
                <div class="has-padding-t10">
                    <div class="columns">
                        <div class="column">
                            <btn
                                class="is-block"
                                type="cancel"
                                v-html="__('Cancel')"
                                v-on:click="isOpenDeleteModal = false"
                            >
                            </btn>
                        </div>
                        <div class="column">
                            <btn
                                class="is-block"
                                type="error"
                                v-html="__('Delete')"
                                v-on:click="deleteEvent"
                            >
                            </btn>
                        </div>
                    </div>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
import { Btn } from '@teamfurther/cinderblock';
import { DataTable } from '@teamfurther/cinderblock';
import { Modal } from '@teamfurther/cinderblock';
import EventRepository from '../../repositories/EventRepository';
import store from '../../store';
import MessageHandler from '../../messageHandler';
import { snakeCase } from 'change-case';

export default {
    components: {
        Btn,
        DataTable,
        Modal
    },
    data: function() {
        return {
            deletingId: null,
            errors: {},
            isOpenDeleteModal: false,
            events: [],
            eventsRepository: new EventRepository(),
            tableData: {
                columnNames: {
                    title: this.__('Title'),
                    shortDescription: this.__('Short description'),
                    startAt: this.__('Start At')
                },
                items: [],
                sortableColumns: ['title', 'startAt']
            }
        };
    },
    methods: {
        deleteEvent: async function() {
            try {
                await this.eventsRepository.deleteEvent(this.deletingId);

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('Event was successfully deleted.'),
                        this.__('Success.'),
                        'success'
                    )
                );

                await this.getEvents();
            } catch (e) {
                console.error(e);
            } finally {
                this.isOpenDeleteModal = false;
            }
        },
        getEvents: async function(sort = '') {
            this.events = await this.eventsRepository.getEvents(sort);
            let items = [];

            this.events.forEach(event => {
                items.push(this.transformEventData(event));
            });

            this.$set(this.tableData, 'items', items);
        },
        transformEventData: function(event) {
            let actions = [
                {
                    title: this.__('Participants'),
                    url: `/admin#/events/${event.id}/participants`
                }
            ];

            actions.push({
                class: 'is-red',
                method: 'showDeleteModal',
                title: this.__('Delete')
            });
            actions.push({
                title: this.__('Edit'),
                url: '/admin#/events/' + event.id + '/edit'
            });

            return {
                values: {
                    id: event.id,
                    shortDescription:
                        event.short_description.length > 80
                            ? `${event.short_description.substring(0, 80)}...`
                            : event.short_description,
                    title: event.title,
                    startAt: event.start_at
                },
                actions: actions
            };
        },
        showDeleteModal: function(data) {
            this.deletingId = data.id;
            this.isOpenDeleteModal = true;
        },
        sortDataTable: function(sortByColumn) {
            if (sortByColumn.match(/^-/)) {
                this.getEvents('-' + snakeCase(sortByColumn));
            } else {
                this.getEvents(snakeCase(sortByColumn));
            }
        }
    },
    mounted: function() {
        this.getEvents();
    }
};
</script>
